/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../banking/account_model';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "dashboard": {
            "nested": {
              "account": {
                "nested": {
                  "AccountType": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "FOLDERS_ACCOUNT": 1
                    }
                  },
                  "FoldersAccountMetadata": {
                    "fields": {
                      "category": {
                        "type": ".squareup.banking.Category",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "AccountMetadata": {
                    "fields": {
                      "foldersAccount": {
                        "type": ".squareup.bbfrontend.dashboard.account.FoldersAccountMetadata",
                        "id": 1
                      }
                    },
                    "nested": {
                      "metadata": {
                        "oneof": ["foldersAccount"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.account?.nested?.AccountType && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.account?.nested?.FoldersAccountMetadata && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.account?.nested?.AccountMetadata) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE AccountType @ squareup/bbfrontend/dashboardweb/account/account.proto at 12:1
 */
export const AccountType = $root.lookupEnum('squareup.bbfrontend.dashboard.account.AccountType').values;
/**
 * SOURCE FoldersAccountMetadata @ squareup/bbfrontend/dashboardweb/account/account.proto at 17:1
 */
export const FoldersAccountMetadata = $root.lookupType('squareup.bbfrontend.dashboard.account.FoldersAccountMetadata');
fixType(FoldersAccountMetadata, {
  category: {
    required: true
  }
});
Builder.createAndAttachToType(FoldersAccountMetadata);
/**
 * SOURCE AccountMetadata @ squareup/bbfrontend/dashboardweb/account/account.proto at 21:1
 */
export const AccountMetadata = $root.lookupType('squareup.bbfrontend.dashboard.account.AccountMetadata');
fixType(AccountMetadata);
Builder.createAndAttachToType(AccountMetadata);